import { render, staticRenderFns } from "./DSTable.vue?vue&type=template&id=6da6e720&scoped=true&"
import script from "./DSTable.vue?vue&type=script&lang=js&"
export * from "./DSTable.vue?vue&type=script&lang=js&"
import style0 from "./DSTable.vue?vue&type=style&index=0&id=6da6e720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6e720",
  null
  
)

export default component.exports